(function () {
  'use strict';

  /**
   * 商品详情与变体切换埋点。
   *
   * 依赖：
   * sensors-click-tracking.js 必须先加载，并提供 window.jiniuTracking。
   * 商品与变体数据由 jiniu-tracking-loader.liquid 写入页面上下文。
   */
  const tracking = window.jiniuTracking;
  const product = window.jiniuTrackingContext?.productDetail;

  if (!tracking || !product?.productId || !Array.isArray(product.variants)) {
    return;
  }

  const EVENT_NAME = 'product_detail_view';
  const variantsById = new Map(
    product.variants.map((variant) => [String(variant.id), variant])
  );
  let currentVariantId = String(product.selectedVariantId || '');

  function getStoredVehicle() {
    try {
      const vehicle = JSON.parse(window.localStorage.getItem('ymme_garage'));

      return vehicle && typeof vehicle === 'object' ? vehicle : null;
    } catch (error) {
      return null;
    }
  }

  function getFitmentValues(variant) {
    if (Array.isArray(variant.fitmentValues)) {
      return variant.fitmentValues.map(String);
    }

    if (
      variant.fitmentValues === null ||
      variant.fitmentValues === undefined ||
      variant.fitmentValues === ''
    ) {
      return [];
    }

    return [String(variant.fitmentValues)];
  }

  function getFitmentProperties(variant) {
    const vehicle = getStoredVehicle();

    if (!vehicle) {
      return {
        is_fittable: '',
        vehicle_info: ''
      };
    }

    const vehicleParts = [
      vehicle.year,
      vehicle.make,
      vehicle.model,
      vehicle.engine
    ].map((value) =>
      value === null || value === undefined ? '' : String(value).trim()
    );
    const fitmentKey = vehicleParts.join('|');
    const isFittable = getFitmentValues(variant).some((value) => {
      const normalizedValue = value.trim();

      return (
        normalizedValue === fitmentKey ||
        normalizedValue.toLowerCase().includes('universal')
      );
    });

    return {
      is_fittable: isFittable ? '是' : '否',
      vehicle_info: vehicleParts.join(' ').replace(/\s+/g, ' ').trim()
    };
  }

  function toNumber(value) {
    const numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue : 0;
  }

  function publishProductDetail(
    variant,
    previousVariantId,
    optionName,
    optionValue
  ) {
    tracking.publish(EVENT_NAME, {
      product_type: String(product.productType || ''),
      product_id: String(product.productId),
      previous_variant_id: String(previousVariantId || ''),
      variant_id: String(variant.id),
      variant_name: String(variant.name || ''),
      msku: String(variant.msku || ''),
      option_name: String(optionName || ''),
      option_value: String(optionValue || ''),
      price: toNumber(variant.price),
      compare_at_price: toNumber(variant.compareAtPrice),
      availability: variant.available ? 'in_stock' : 'out_of_stock',
      ...getFitmentProperties(variant)
    });
  }

  function getOptionName(element, eventPath) {
    const optionGroup = eventPath.find(
      (current) =>
        current instanceof Element && current.matches('[data-option-name]')
    );
    const fieldsetName = optionGroup?.getAttribute('data-option-name');

    if (fieldsetName) {
      return fieldsetName;
    }

    const inputName = element.getAttribute('name') || '';
    const bracketMatch = inputName.match(/^options\[(.*)]$/);
    return bracketMatch ? bracketMatch[1] : inputName;
  }

  const initialVariant = variantsById.get(currentVariantId);

  if (initialVariant) {
    publishProductDetail(initialVariant, '', '', '');
  }

  // 捕获阶段保存操作信息，避免主题重建单选按钮后 event.target 脱离 DOM。
  document.addEventListener(
    'change',
    function (event) {
      if (!(event.target instanceof Element)) {
        return;
      }

      const eventPath =
        typeof event.composedPath === 'function' ? event.composedPath() : [];
      const picker =
        eventPath.find(
          (current) =>
            current instanceof Element &&
            current.matches('variant-radios, variant-selects')
        ) || event.target.closest('variant-radios, variant-selects');

      if (!picker) {
        return;
      }

      const optionName = getOptionName(event.target, eventPath);
      const optionValue = event.target.value;
      const publishChangedVariant = () => {
        const nextVariantId = String(picker.currentVariant?.id || '');
        const nextVariant = variantsById.get(nextVariantId);

        if (!nextVariant || nextVariantId === currentVariantId) {
          return;
        }

        const previousVariantId = currentVariantId;
        currentVariantId = nextVariantId;

        publishProductDetail(
          nextVariant,
          previousVariantId,
          optionName,
          optionValue
        );
      };

      // 在下一个任务中读取变体，确保主题的 change 监听器已更新 currentVariant。
      window.setTimeout(publishChangedVariant, 0);
    },
    { capture: true }
  );
})();
